"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthNetworkType = void 0;
var AuthNetworkType;
(function (AuthNetworkType) {
    AuthNetworkType["EVM"] = "evm";
    AuthNetworkType["SOLANA"] = "solana";
    AuthNetworkType["APTOS"] = "aptos";
})(AuthNetworkType = exports.AuthNetworkType || (exports.AuthNetworkType = {}));
//# sourceMappingURL=AuthNetworkType.js.map